module.exports = __webpack_public_path__ + "static/group-3-7c2f57f5d02207989c11386868343d1a.png";